import { Outlet, createFileRoute } from '@tanstack/react-router';
import { AppShell, Center, Container, Group, Stack, Text, Title } from '@mantine/core';

function AuthShell() {
  return (
    <AppShell padding="md">
      <AppShell.Main>
        <Center mih="100vh">
          <Container size="xs" w="100%">
            <Stack gap="lg">
              <Group gap="xs" justify="center">
                <Title order={2}>LeadSync</Title>
              </Group>
              <Outlet />
              <Text ta="center" c="dimmed" size="xs">
                Phase 0 — Auth UI lands in Feature 1.
              </Text>
            </Stack>
          </Container>
        </Center>
      </AppShell.Main>
    </AppShell>
  );
}

export const Route = createFileRoute('/auth')({ component: AuthShell });
